import React from 'react';
import ProfileLayout from './ProfileLayout';
import { CrmTokensPanel } from '../crm_email/CrmTokensPage';

// The Customer.io token section of Settings.
//
// Its own route rather than a block on the account page: a token is a credential a CRM user is
// sent to fetch ("open Settings → Customer.io token"), and that instruction needs a link to point
// at. The route is what makes the link possible.
export default function CrmTokenSettingsPage() {
  return (
    <ProfileLayout>
      <div>
        <h2 className="text-sm font-bold text-ink mb-1">Customer.io token</h2>
        <p className="text-xs text-ink-dim mb-4 font-medium">
          Customer.io calls this service's localization endpoint with a token to reformat numbers for
          each recipient's language. It is yours alone: paste it into the workspace you set up, and
          you can revoke it without affecting anyone else. Never share it — a colleague mints their
          own here.
        </p>
        <CrmTokensPanel />
      </div>
    </ProfileLayout>
  );
}
